(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gm-ratti-converter-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-weight-converter')) {
    customElements.define('gm-weight-converter', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.inputs = Array.from(this.querySelectorAll('[data-unit]'));
        this.controls = this.querySelector('[data-controls]');
        this.factorSelect = this.querySelector('[data-factor]');
        this.customFactor = this.querySelector('[data-custom]');
        this.customWrap = this.querySelector('[data-custom-wrap]');
        this.factorLabel = this.querySelector('[data-current-factor]');
        this.error = this.querySelector('[data-error]');
        this.result = this.querySelector('[data-result]');
        this.rows = Array.from(this.querySelectorAll('[data-ratti]'));
        if (this.inputs.length !== 4 || !this.controls || !this.factorSelect || !this.customFactor || !this.error || !this.result) return;
        this.bound = true;
        this.last = { unit: 'carat', value: '1' };
        this.inputs.forEach((input) => input.addEventListener('input', () => {
          this.last = { unit: input.dataset.unit, value: input.value, badInput: input.validity.badInput };
          this.update();
        }));
        this.factorSelect.addEventListener('change', () => this.update());
        this.customFactor.addEventListener('input', () => this.update());
        this.querySelector('[data-reset]').addEventListener('click', () => {
          this.factorSelect.value = '182';
          this.customFactor.value = '182';
          this.last = { unit: 'carat', value: '1' };
          this.inputs.find((input) => input.dataset.unit === 'carat').value = '1';
          this.update();
        });
        this.update();
        this.controls.disabled = false;
      }
      format(value) {
        return String(Number(value.toPrecision(12)));
      }
      message(template, values) {
        return template.replace(/\[\[(\w+)\]\]/g, (_, key) => values[key] ?? '');
      }
      convert(value, unit, factor) {
        const mg = unit === 'ratti' ? value * factor : unit === 'carat' ? value * 200 : unit === 'gram' ? value * 1000 : value;
        const values = { ratti: mg / factor, carat: mg / 200, gram: mg / 1000, mg };
        return Object.values(values).every((number) => Number.isFinite(number) && (value === 0 || number > 0)) ? values : null;
      }
      update() {
        this.inputs.forEach((input) => input.removeAttribute('aria-invalid'));
        this.customFactor.removeAttribute('aria-invalid');
        this.customWrap.hidden = this.factorSelect.value !== 'custom';
        const rawFactor = this.factorSelect.value === 'custom' ? this.customFactor.value.trim() : this.factorSelect.value;
        const factor = Number(rawFactor);
        const factorValid = rawFactor !== '' && Number.isFinite(factor) && factor > 0;
        this.factorLabel.textContent = factorValid ? this.message(this.dataset.factorLabel, { factor: String(factor) }) : this.dataset.factorError;
        this.rows.forEach((row) => {
          const values = factorValid ? this.convert(Number(row.dataset.ratti), 'ratti', factor) : null;
          row.querySelector('[data-reference-carat]').textContent = values ? this.format(values.carat) : '—';
          row.querySelector('[data-reference-gram]').textContent = values ? this.format(values.gram) : '—';
        });
        const raw = this.last.value.trim();
        const value = Number(raw);
        const rawUnderflow = value === 0 && /[1-9]/.test(raw.split(/[eE]/)[0]);
        const negativeUnderflow = rawUnderflow && raw.startsWith('-');
        const values = factorValid && raw !== '' && !this.last.badInput && !rawUnderflow && Number.isFinite(value) && value >= 0 ? this.convert(value, this.last.unit, factor) : null;
        let error = '';
        if (!factorValid) {
          error = this.dataset.factorError;
          this.customFactor.setAttribute('aria-invalid', 'true');
        } else if (this.last.badInput || negativeUnderflow || (raw !== '' && (!Number.isFinite(value) || value < 0))) {
          error = this.dataset.invalid;
        } else if (raw !== '' && !values) {
          error = this.dataset.rangeError;
        }
        this.error.textContent = error;
        this.error.hidden = !error;
        if (!values) {
          this.inputs.forEach((input) => {
            if (input.dataset.unit !== this.last.unit) input.value = '';
            else if (error && factorValid) input.setAttribute('aria-invalid', 'true');
          });
          this.result.textContent = error ? '' : this.dataset.empty;
          return;
        }
        this.inputs.forEach((input) => {
          if (input.dataset.unit !== this.last.unit) input.value = this.format(values[input.dataset.unit]);
        });
        this.result.textContent = this.message(this.dataset.resultLabel, Object.fromEntries(Object.entries(values).map(([unit, number]) => [unit, this.format(number)])));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
